import { api } from './client';

export interface BodyPreferencesDto {
  activeFields?: string[] | null;
}

export const bodyPreferencesApi = {
  get: () => api<BodyPreferencesDto>('/api/health/body/preferences'),
  save: (p: BodyPreferencesDto) =>
    api<BodyPreferencesDto>('/api/health/body/preferences', {
      method: 'PUT',
      body: JSON.stringify(p),
    }),
};
